import React from 'react';

const benefits = [
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M18.364 5.636a9 9 0 010 12.728M15.536 8.464a5 5 0 010 7.072M6.343 6.343a9 9 0 000 12.728M9.172 9.172a5 5 0 000 7.072M12 12h.01" />
      </svg>
    ),
    title: 'Works Offline',
    description: 'Access key data even without an internet connection'
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
    title: 'Faster Loading',
    description: 'Cached resources load instantly on repeat visits'
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
      </svg>
    ),
    title: 'Native App Feel',
    description: 'Full-screen experience without browser chrome'
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      </svg>
    ),
    title: 'Home Screen Icon',
    description: 'Quick access directly from your device home screen'
  }
];

const InstallBenefits = () => {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <h2 className="text-base font-semibold text-foreground mb-4">Why install?</h2>
      <div className="grid grid-cols-2 gap-3">
        {benefits?.map((benefit, index) => (
          <div key={index} className="flex flex-col gap-2 p-3 bg-muted/50 rounded-lg">
            <div className="text-primary">{benefit?.icon}</div>
            <div>
              <p className="text-sm font-medium text-foreground">{benefit?.title}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{benefit?.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InstallBenefits;
